<template>
    <!-- <div @mouseover="showTipNumber=true" @mouseleave="showTipNumber=false"> -->
    <div>
        <!-- <div class="addTips" v-show="showTipNumber">
             <div class="tooltip_area">
                <ul>
                    <li>
                        <span style="background:#FF0000"></span>交易失败{{prodArr[0]}}
                    </li>
                    <li>
                        <span style="background:#FF8A00"></span>面额不符{{prodArr[1]}}
                    </li>
                    <li>
                        <span style="background:#33CC99"></span>交易成功{{prodArr[2]}}
                    </li>
                    <li>
                        <span style="background:#1A86FE"></span>交易中{{prodArr[3]}}
                    </li>
                    <li>
                        <span style="background:#D8D8D8"></span>冻结中{{prodArr[4]}}
                    </li>
                    <li>
                        <span style="background:#EEEEEE"></span>待售中{{prodArr[5]}}
                    </li>
                </ul>
            </div>
        </div> -->
        <el-popover
            placement="top"
            width="120"
            trigger="hover">
            <div class="addTips">
                <div class="tooltip_area">
                    <ul>
                        <li>
                            <span style="background:#FF0000"></span>交易失败{{prodArr[0]}}
                        </li>
                        <li>
                            <span style="background:#FF8A00"></span>面额不符{{prodArr[1]}}
                        </li>
                        <li>
                            <span style="background:#33CC99"></span>交易成功{{prodArr[2]}}
                        </li>
                        <li>
                            <span style="background:#1A86FE"></span>交易中{{prodArr[3]}}
                        </li>
                        <!-- <li>
                            <span style="background:#D8D8D8"></span>冻结中{{prodArr[4]}}
                        </li> -->
                        <li>
                            <span style="background:#EEEEEE"></span>待售中{{prodArr[5]}}
                        </li>
                    </ul>
                </div>
            </div>
            <div slot="reference" class="progress_bar">
                <ul>
                    <li v-for="item in widthList" :class="item.color" :key="item.color" :style="{width: item.width+'%'}"></li>
                </ul>
            </div>
        </el-popover>
	</div>
</template>

<script>
export default {
    data(){
        return{
            // propList:this.proplist,
            prodArr: this.proplist,
            showTipNumber: false
        }
    },
    props:['proplist'],
    watch: {
        proplist: {
            handler(newValue, oldValue) {
                this.prodArr = newValue
            },
            deep: true
        }
    },
    computed:{
        total(){
            let sum = 0;
            // this.propList.forEach(item => {
            this.prodArr.forEach(item => {
                sum = sum+item;
            })
            return sum
        },
        widthList(){
            let widthArray = [];
            const colorList = ['red', 'yellow', 'green', 'blue', 'gray', 'lightgray'];
            for(let i=0; i<this.prodArr.length;i++){
                let percentNum = 0;
                for(let j=0; j<=i; j++){
                    percentNum = percentNum+this.prodArr[j]
                }
                widthArray.push({
                    'color': colorList[i],
                    'width': (percentNum/this.total*100).toFixed(2)
                })
            }
            return widthArray
        }
    }
}
</script>

<style scoped lang="scss">
.addTips{
    // position: absolute;
    // background: #fff;
    // margin-top: -160px;
    // margin-left:35px;
    // z-index: 99999;
    // border:1px solid #f5f0f0;
    // border-radius: 4px;
    // box-shadow: 0 0 10px #d8d7d7;
    ul{
        width: 134px;
        span{
            width: 10px;
            height: 10px;
            border-radius: 5px;
            display: inline-block;
            margin-right: 10px;
        }
        li{
            width: 100%;
            padding-left: 30px;
            height: 30px;
            line-height: 30px;
        }
    }
}
.progress_bar{
    width:100%;
    height: 10px;
    min-width: 160px;
    cursor: pointer;
    &:hover{
        height: 16px;
        ul{
            height: 16px;
            li{
                height:16px;
                border-radius: 8px;
            }
        }
    } 
    ul{
        width: 100%;
        height: 10px;
        background: #EEEEEE;
        border-radius: 5px;
        position: relative;
        li{
            border-radius: 5px;
            height: 10px;
            position: absolute;
        }
    }
    .red{
        background: #FF0000;
        z-index: 10
    }
    .yellow{
        background: #FF8A00;
        z-index: 9
    }
    .green{
        background: #33CC99;
        z-index: 8
    }
    .blue{
        background: #1A86FE;
        z-index:7
    }
     .gray{
        background: #D8D8D8;
        z-index:6
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/progress.vue